import { render } from "./ProcedureCard.vue?vue&type=template&id=164e9ce6&scoped=true"
import script from "./ProcedureCard.vue?vue&type=script&lang=js"
export * from "./ProcedureCard.vue?vue&type=script&lang=js"

import "./ProcedureCard.vue?vue&type=style&index=0&id=164e9ce6&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164e9ce6"]])

export default __exports__